import React from 'react';
import { InputField } from 'components/form';
import { useFormContext } from 'react-hook-form';

export const InventoryTableFilters = () => {
  const { control, setValue } = useFormContext();

  const handleVinOrStockNumberChange = (value: string) => {
    const parsedYear = Number(value);

    setValue('filters', {
      vin: value,
      stockId: value,
      make: [value],
      model: [value],
      yearTo: !isNaN(parsedYear) && parsedYear > 0 ? parsedYear : undefined,
      yearFrom: !isNaN(parsedYear) && parsedYear > 0 ? parsedYear : undefined,
    });
  };

  return (
    <InputField
      control={control}
      name="filters.vin"
      label="Vin, Stock Number, Year/Make/Model"
      extraAction={{ cb: handleVinOrStockNumberChange }}
      inputProps={{
        variant: 'outlined',
      }}
    />
  );
};
